var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-secondary order-4",class:_vm.def.isReadOnly === 'true'
             || _vm.def.isReadOnly === 'update'
             || _vm.readOnly
             || _vm.dataChanged ? 'readonly' : '',attrs:{"href":"#"},on:{"click":function($event){return _vm._newListener($event)}}},[_c('span',{staticClass:"icon wb-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }